export const CONST = {
  // status :[
  //   {id:0 , en:"Awaiting payment" , fa:"در انتظار پرداخت"},
  //   {id:1 , en:"under review" , fa:"در حال بررسی"},
  //   {id:2 , en:"Failed Pay" , fa:"پرداخت ناموفق"},
  //   {id:3 , en:"Awaiting payment" , fa:"ناموفق"},
  //   {id:4 , en:"Send to the Nationality Office" , fa:"   (منتظر OKTB) ارسال به اداره اتباع"},
  //   {id:5 , en:"Send to the Nationality Office" , fa:" (منتظر منتظر نامه فرماندهی) ارسال به اداره اتباع"},
  //   {id:6 , en:"under review" , fa:"OKTB ارسال شده منتظر فرماندهی"},
  //   {id:8 , en:"Active" , fa:"در جریان"},
  //   {id:9 , en:"under review" , fa:"منقضی شده"},
  //   {id:10 , en:"OKTB" , fa:"OKTB"},
  // ],
  adminStatus: [
    { id: 0, en: "Awaiting payment", fa: "در انتظار پرداخت" },
    { id: 1, en: "َUnder Review", fa: "درخواست جدید" },
    { id: 2, en: "Failed payment", fa: "پرداخت ناموفق" },
    { id: 3, en: "Canceled", fa: "کنسل شده", bgColor: '#ffe4e6', color: '#e53232' },
    { id: 4, en: "Send to the Nationality Office", fa: "درخواست ویزا شد" },
    { id: 5, en: "Send to the Nationality Office", fa: "درخواست ویزا شد" },
    { id: 6, en: "OKTB", fa: "OKTB" },
    { id: 7, en: "under fsreview", fa: "؟7؟" },
    { id: 8, en: "Active", fa: "فعال" },
    { id: 9, en: "Expired", fa: "منقضی شده" },
    { id: 10, en: "Wait For Automation Number ", fa: "در انتظار دریافت شماره اتوماسیون" },
    { id: 15, en: "Completed", fa: "تکمیل شده" },
  ],
  agentStatus: [
    { id: 0, en: "Awaiting payment", fa: "در انتظار پرداخت" },
    { id: 1, en: "under review", fa: "در حال بررسی" },
    { id: 2, en: "Awaiting payment", fa: "پرداخت ناموفق" },
    { id: 3, en: "Canceled", fa: "کنسل شده", bgColor: '#ffe4e6', color: '#e53232' },
    { id: 4, en: "Send to the Nationality Office", fa: "در حال پردازش" },
    { id: 5, en: "Send to the Nationality Office", fa: "در حال پردازش" },
    { id: 6, en: "OKTB", fa: "OKTB" },
    { id: 7, en: "under review", fa: "?7?" },
    { id: 8, en: "Active", fa: "در جریان" },
    { id: 9, en: "under review", fa: "منقضی شده" },
    { id: 10, en: "Send to the Nationality Office", fa: "در حال پردازش" },
    { id: 15, en: "Completed", fa: "تکمیل شده" },
  ],
  cancelVisaStatus: [
    { id: 0, en: "Pending", fa: "در انتظار" },
    { id: 1, en: "Aproved", fa: "تایید شده" },
    { id: 2, en: "Rejected", fa: "رد شده" },
  ]
}
